
import React, { useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import * as handlers from "../../../../../../../../_redux/selected-user/selectedUserHandlers";


const UpdateReserveAccountInstantModal = props => {
  /* Redux State */
  const userBasic = useSelector(({selectedUser}) => selectedUser.data.profile.basic, shallowEqual);
  const [validated, setValidated] = useState(false);
  const [instantDeposit, setInstantDeposit] = useState(props.updateReserveAccountInstantModal?.instantDeposit);
  // Redux dispatch
  const dispatch = useDispatch();

  /* Form submission */
  const handleSubmit = e =>  {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    if (form.checkValidity() === true) {
      props.setUpdateReserveAccountInstantModal(null);
      dispatch(handlers.updateReserveAccountInstant(props.match.params.userId, props.match.params.accountId, { meta: userBasic, ...props.updateReserveAccountInstantModal, instantDeposit}));
    }
    setValidated(true);
  }

  return (
    <Modal
        show={!!props.updateReserveAccountInstantModal}
        onHide={_ => props.setUpdateReserveAccountInstantModal(null)}
        aria-labelledby="contained-modal-title-vcenter"
        keyboard={false}
        onExited={_ => setValidated(false)}
      >
      <Form
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
      >
        <Modal.Header >
          <Modal.Title id="contained-modal-title-vcenter">
          <i className="flaticon2-layers-2 text-primary mr-2"></i> Update Reserve Account Instant Deposit
          </Modal.Title>
          <button type="button" className="close" onClick={_ => props.setUpdateReserveAccountInstantModal(null)}>
              <span aria-hidden="true" className="d-block">×</span>
              <span className="sr-only">Close</span>
           </button>
        </Modal.Header>
        <Modal.Body>
            <Form.Group controlId="partnerId" className="px-5">
                <Form.Label >Instant Deposit Status</Form.Label>
                <Form.Control
                    required
                    as="select"
                    className="mr-sm-2"
                    custom
                    onChange={e => setInstantDeposit(e.currentTarget.value === "true")}
                    name="instantDeposit"
                    defaultValue={(props.updateReserveAccountInstantModal?.instantDeposit ? "true" : "false")} 
                >
                    <option value="true">Enable</option>
                    <option value="false">Disable</option>
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  Select Instant Deposit Status
                </Form.Control.Feedback>
            </Form.Group>
        </Modal.Body>
        <Modal.Footer>
            <button
                type="button"
                onClick={_=> props.setUpdateReserveAccountInstantModal(null)}
                className="btn btn-light btn-elevate px-4"
            >
                Cancel
            </button>
            <> </>
            <button
                type="submit"
                className="btn btn-primary btn-elevate px-4 ml-4"
                disabled={props.updateReserveAccountInstantModal?.instantDeposit === instantDeposit}
            >
                Update
            </button>
        </Modal.Footer>
    </Form>
      </Modal>

        );
}

export default UpdateReserveAccountInstantModal;